"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkRegion = exports.EnvConfigPrototype = void 0;
var env_config_1 = require("./env-config");
Object.defineProperty(exports, "EnvConfigPrototype", { enumerable: true, get: function () { return env_config_1.EnvConfigPrototype; } });
Object.defineProperty(exports, "NetworkRegion", { enumerable: true, get: function () { return env_config_1.NetworkRegion; } });
